var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-footer"},[_c('div',[_vm._t("left")],2),_c('div',{staticClass:"mid"},[_vm._t("default")],2),_c('div',[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }